module.exports = __webpack_public_path__ + "img/live_sesson.e76824c2.svg";